const DayPicker = require('react-day-picker');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const Column = Form.Column;
const Row = Form.Row;
const React = require('react');
const createReactClass = require('create-react-class');
const FormUtility = FuzzyReaction.Components.ResourceBinding.Form.FormUtilityMixin;
const PropTypes = require('prop-types');

const AM = 'a.m.';
const PM = 'p.m.';

const DayTimePicker = createReactClass({
    displayName: 'DayTimePicker',

    propTypes: {
        fieldKey: PropTypes.string.isRequired,
        label: PropTypes.string,
        disabled: PropTypes.bool,
    },

    mixins: [FormUtility],

    getInitialState: function () {
        return {
            fieldValue: null,
            selectedDay: null,
            selectedHour: null,
            selectedMinute: null,
            selectedAmPm: null,
        }
    },

    UNSAFE_componentWillReceiveProps: function (nextProps) {
        const fieldValue = this._findValueByPath(nextProps.bindResource, nextProps.fieldKey)
        let initDate = fieldValue ? new Date(fieldValue) : undefined;

        let selectedDay = undefined;
        let selectedHour = '12';
        let selectedMinute = '00';
        let selectedAmPm = PM;

        if (initDate) {
            selectedDay = initDate;
            selectedHour = initDate.getHours() > 12 ? initDate.getHours() - 12 : initDate.getHours();
            selectedMinute = initDate.getMinutes();
            selectedAmPm = initDate.getHours() >= 12 ? PM : AM;
        }

        this.setState({
            fieldValue: fieldValue,
            selectedDay: selectedDay,
            selectedHour: selectedHour,
            selectedMinute: selectedMinute,
            selectedAmPm: selectedAmPm,
        });
    },

    buildHourOptions: function () {
        const hours = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];

        return hours.map(function (value) {
            return <option key={value} value={value}>{value}</option>
        });
    },

    buildMinuteOptions: function () {
        const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

        return minutes.map(function (value) {
            return <option key={value} value={value}>{value}</option>
        });
    },

    buildAmPmOptions: function () {
        const amPm = [AM, PM];

        return amPm.map(function (value) {
            return <option key={value} value={value}>{value}</option>
        });
    },

    buildDateTimeStr: function () {
        if (this.state.selectedDay) {
            let d = new Date(this.state.selectedDay),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) {
                month = '0' + month;
            }
            if (day.length < 2) {
                day = '0' + day;
            }

            let hours = Number(this.state.selectedHour);
            const minutes = Number(this.state.selectedMinute);

            if (this.state.selectedAmPm === PM && hours < 12) {
                hours = hours + 12;
            } else if (this.state.selectedAmPm === AM && hours === 12) {
                hours = hours - 12;
            }

            let sHours = hours.toString();
            let sMinutes = minutes.toString();
            if (hours < 10) {
                sHours = "0" + sHours;
            }
            if (minutes < 10) {
                sMinutes = "0" + sMinutes;
            }

            this.handleChange({
                target : {
                    value: year + '-' + month + '-' + day + ' ' + sHours + ":" + sMinutes + ":00"
                }
            });
        }
    },

    handleDayClick: function (day) {
        if (this.props.disabled) {
            return;
        }
        this.setState({
            selectedDay: day
        }, function () {
            this.buildDateTimeStr();
        });
    },

    handleHourClick: function (event) {
        this.setState({
            selectedHour: event.target.value
        }, function () {
            this.buildDateTimeStr();
        });
    },

    handleMinuteClick: function (event) {
        this.setState({
            selectedMinute: event.target.value
        }, function () {
            this.buildDateTimeStr();
        });
    },

    handleAmPmClick: function (event) {
        this.setState({
            selectedAmPm: event.target.value
        }, function () {
            this.buildDateTimeStr();
        });
    },

    render: function () {
        return (
            <Column grid="lg" size="6">
                <Row>
                    <div className="form-group form-inline">
                        <label className="control-label">{this.props.label}</label>
                        <br/>
                        <DayPicker
                            month={this.state.selectedDay}
                            canChangeMonth={!this.props.disabled}
                            onDayClick={this.handleDayClick}
                            selectedDays={this.state.selectedDay}
                        />
                        <select className="form-control offset-md-1" onChange={this.handleHourClick}
                                value={this.state.selectedHour || ''} disabled={this.props.disabled}>
                            {this.buildHourOptions()}
                        </select>
                        <select className="form-control" onChange={this.handleMinuteClick}
                                value={this.state.selectedMinute || ''} disabled={this.props.disabled}>
                            {this.buildMinuteOptions()}
                        </select>
                        <select className="form-control" onChange={this.handleAmPmClick}
                                value={this.state.selectedAmPm || ''} disabled={this.props.disabled}>
                            {this.buildAmPmOptions()}
                        </select>
                        <input disabled={true} type="text" className="form-control offset-md-1"
                               style={{width: '150px'}} placeholder="YYYY-mm-dd hh:mm:ss"
                               value={this.state.fieldValue || ''} onChange={this.handleChange}/>UTC
                    </div>
                </Row>
            </Column>
        )
    },
});

module.exports = DayTimePicker;
